















































































































import Vue, { PropOptions } from 'vue';
import * as TypeVariable from '@/parts/VariableInput.vue';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';
import mv from './mixins-views2';
import InfiniteLoading from 'vue-infinite-loading';

export default Vue.extend({
  name: 'Engineer',
  mixins: [mv],
  components: { InfiniteLoading},
  props: {
    myData: Object as PropOptions<Models.ICoordinator>,
    getDatas: Object as PropOptions<Models.IGetDatas>,
  },
  computed: {},
  data() {
    return {
      inputData: new Models.CEngineer(),
      items: [
        {key: 'engineerName', name: 'エンジニア名', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'initials', name: 'イニシャル', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99, class: 'ini' },
        {key: 'responsibleID', name: '担当者', type: TypeVariable.INPUT_TYPE.SELECT, required: true, error: '', options: PClass.CONST.ARRAY.NORMAL, class: 'flat'},
        {key: 'subject', name: '件名', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 1500},
        {key: 'introduction', name: '紹介文', type: TypeVariable.INPUT_TYPE.TEXTAREA, required: false, error: '', max: 1500},
      ] as TypeVariable.IVariableInput[],
      thDatas: [
        {key: 'engineerName', name: 'エンジニア名', sort: true},
        {key: 'initials', name: 'イニシャル', sort: true},
        {key: 'responsibleName', name: '担当者', sort: true},
        {key: 'createDate', name: '作成日', sort: true},
        {key: 'updateDate', name: '更新日', sort: true},
      ] as TypeVariable.IVariableInput[],
      inputFiles: [] as File[],
      inputFilesError: '',
      tmpRejects: [] as number[],
      inputRejects: [] as number[],
      rejectModal: false,
      localData: {} as Models.ILocalData,
      listDispModal: false,
      infiniteId: 0,
      ngSearchWord: '',
      localKey: 'engineer',
    };
  },
  async mounted() {
    // ローカルデータ初期化
    this.localData = new Models.CLocalData('engineerName', this.thDatas);
    (this as any).mixSetLocalData(this.localKey);
    // データ読み込み
    await (this as any).fncGetDatas(true);
  },
  methods: {
    firstFunction(resData: any) {
      this.getDatas.getCoordinatorDatas = resData.data.coordinators;
      this.getDatas.getClientDatas = resData.data.clients;
      this.items[2].options = PClass.CONST.ARRAY.NORMAL.concat(this.getDatas.getCoordinatorDatas.map((v) => ({text: v.coordinatorName, value: v.id})));
    },
    async onClickEditMode(engineer: Models.IEngineer) {
      this.$emit('loading', true);
      this.inputData = engineer;
      await this.getReject(engineer.id);
      (this as any).mixChangeMode(PClass.CONST.MODE.EDIT);
      scrollTo(0, 0);
      this.$emit('loading', false);
    },
    onClickNewMode() {
      this.inputData.responsibleID = this.myData.id;
      (this as any).mixChangeMode(PClass.CONST.MODE.NEW);
    },
    onClickCancel() {
      this.inputData = new Models.CEngineer();
      this.inputFiles = [];
      this.tmpRejects = [];
      this.inputRejects = [];
      this.inputFilesError = '';
      (this as any).mixChangeMode(PClass.CONST.MODE.NORMAL);
    },
    async onClickUpdate() {
      this.$emit('loading', true);
      this.inputFilesError = '';
      if (TypeVariable.checkValues(this.inputData, this.items) > 0) {
        this.$emit('loading', false);
        return false;
      }

      // skill check
      if (this.checkFile()) {
        // return false;
      } else {
        if (this.inputFiles.length === 1) {
          if (this.inputFiles[0].size > 512000) {
            this.$emit('info', 'ファイルは500kb以下に\n設定してください。');
            this.$emit('loading', false);
            return;
          }
          this.inputData.attachmentName = this.inputFiles[0].name;
          // console.log(this.inputData.attachmentName);
        }
      }

      const api = new PClass.API();
      const url = (this as any).mixGetMode() === PClass.CONST.MODE.NEW ? 'engineer/new' : 'engineer/edit'
      const res = await api.post<any, {id: number}>(url, this.inputData);

      let success = true;
      if (!res.result.error) {

        let rRes;
        const targetID = res.data.id;
        // 個別の拒絶設定を反映
        if (this.tmpRejects.length > 0) {
          const sendRejects = this.inputRejects.map((v) => ({engineerID: targetID, clientID: v}))
          rRes = await api.post<Models.IEngineerReject[], any>('engineer_reject/', sendRejects);
        } else {
          rRes = await api.delete<any>('engineer_reject/', {id: targetID});
        }
        if (rRes.result.error) {
          this.$emit('info', '個別NG設定に失敗しました。');
        }
        // ファイルをアップロード
        if (this.inputFiles.length === 1) {
          const formData = new FormData();
          const fileType = PClass.Moment.fncGetTime() + '.' + this.inputFiles[0].name.split('.').pop();
          // console.log('filetype', fileType);
          formData.append(`${targetID}/${fileType}`, this.inputFiles[0]);
          this.inputData.id = targetID;
          formData.append(`data`, JSON.stringify(this.inputData));
          formData.append(`fileName`, `${fileType}`);
          const fRes = await api.postFile<any, any>('engineer/skill/update', formData);
          if (!fRes.result.error) {
            // this.getDatas.getEngineerDatas = fRes.data.engineers;
          } else {
            this.$emit('info', fRes.result.message);
            success = false;
          }
        }
        await (this as any).fncGetDatas(true);
        this.onClickCancel()

        if (!success) {
          this.$emit('info', 'ファイル設定に失敗しました。');
        }
      } else {
        this.$emit('info', res.result.message);
      }
      this.$emit('loading', false);
    },
    onClickFileSelect(e: any) {
      this.inputFiles = e.target.files;
    },
    checkFile(): boolean {
      let returnValue = false;
      if (this.inputFiles.length === 1) {
        /*
        if (this.inputFiles[0].name.indexOf('.xlsx') < 0) {
          this.inputFilesError = 'ファイルがxlsx形式ではありません。';
          returnValue = true;
        }
        */
      } else {
        if (this.inputData.attachmentUrl === '') {
          this.inputFilesError = 'ファイルが未選択です。';
          returnValue = true;
        }
      }
      return returnValue;
    },
    onClickCloseRejectModal() {
      this.rejectModal = false;
    },
    async getReject(id: number) {
      const api = new PClass.API();
      const res = await api.get<Models.VEngineerReject>('engineer_reject', {id});
      if (!res.result.error) {
        const ids = res.data.engineerReject.map((v) => (v.clientID));
        this.inputRejects = ids;
        this.tmpRejects = ids.concat();
      }
    },
    onClickSetReject() {
      this.inputRejects = this.tmpRejects.concat();
      this.rejectModal = false;
    },
    async onClickDelete(deleteData: Models.IEngineer) {
      await (this as any).mixDeleteAction('このエンジニアを削除します。\nよろしいでしょうか？', deleteData)
    },
    async infiniteHandler($state: any) {
      await (this as any).mixInfiniteHandler($state)
    },
  },
});

